import { useTranslation } from 'react-i18next';
import { makeStyles, tokens } from '@fluentui/react-components';
import { getWelcomeNameFromToken } from '@moko/utils/src/authHelper';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'baseline',
    gap: tokens.spacingHorizontalXS,
    minWidth: 0,
    maxWidth: '100%',
    margin: 0,
    fontSize: tokens.fontSizeBase300,
    lineHeight: tokens.lineHeightBase300,
    color: tokens.colorNeutralForeground1,
    whiteSpace: 'nowrap',
    '@media (min-width: 769px)': {
      fontSize: tokens.fontSizeBase400,
      lineHeight: tokens.lineHeightBase400,
    },
    '@media (min-width: 1200px)': {
      maxWidth: '320px',
      overflow: 'hidden',
    },
  },
  label: {
    flexShrink: 0,
  },
  name: {
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorBrandForeground1,
    '@media (min-width: 1200px)': {
      minWidth: 0,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
});

const WelcomeMessage = () => {
  const { t } = useTranslation();
  const styles = useStyles();
  const name = getWelcomeNameFromToken();
  if (!name) return null;

  return (
    <p data-layout-context="" className={styles.root}>
      <span className={styles.label}>{t('welcome', 'Welcome')}</span>
      <span className={styles.name}>{name}</span>
    </p>
  );
};

export default WelcomeMessage;
